import React from 'react'
import {
    Typography,
    Grid,
    Container,
    Avatar,
} from '@material-ui/core'
import {
    ArrowBack
} from '@material-ui/icons'
import { CustomAppBar, CustomButton, CustomTextField } from '../../../shared'
import { PANCard, VoterIDCard, Aadhaar, DrivingLicence, Camera1, Camera2, Camera3 } from '../../../assets/images'
import { getContent } from '../../../utils/helper'
import { supportedLanguageMapping } from '../../language/constants'

const Documents = ({ goBack, goToScreen, language, languageJSON, phoneNumber, handleChange, needToForward, send }) => {
    return (
        <div>
            <CustomAppBar title={getContent(languageJSON, 'title_address_verification')}
                leftButton={<CustomButton variant="text" handleChange={goBack} label={<ArrowBack />} />}
                rightButton={<CustomButton variant="text" color="primary" handleChange={() => goToScreen('language', { to: 'documents' })} label={supportedLanguageMapping[language]} />} />
            <Container style={{ padding: 0 }}>
                <Grid container justify="center" alignItems="center" spacing={2} style={{ padding: '2% 0%', height: '100vh', overflow: 'scroll', paddingBottom: 210 }}>
                    <Grid item xs={11}>
                        <Typography variant="h6">
                            {getContent(languageJSON, 'hint_confirm_atleast_one_doc')}
                        </Typography>
                    </Grid>
                    <Grid item xs={11} style={{ backgroundColor: '#F1FEF8' }}>
                        <Typography variant="body1">
                            {getContent(languageJSON, 'label_id_proof')}
                        </Typography>
                        <Grid container justify="center" alignItems="center" spacing={2} style={{ marginTop: '2%' }}>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={PANCard} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_pan')}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={VoterIDCard} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_voter_id')}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={Aadhaar} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_aadhar')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={11} style={{ backgroundColor: '#FEFEF1' }}>
                        <Typography variant="body1">
                            {getContent(languageJSON, 'label_address_proof')}
                        </Typography>
                        <Grid container justify="center" alignItems="center" spacing={2} style={{ marginTop: '2%' }}>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={DrivingLicence} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_dl')}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={VoterIDCard} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_voter_id')}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={Aadhaar} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_aadhar')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={11} style={{ backgroundColor: '#F4F1FE' }}>
                        <Typography variant="body1">
                            {getContent(languageJSON, 'hint_working_camera')}
                        </Typography>
                        <Grid container justify="center" alignItems="center" spacing={2} style={{ marginTop: '2%' }}>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={Camera1} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_video')}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={Camera2} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_front_camera')}</Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Avatar variant="square" style={{ width: '100%', height: '8vh', borderTopLeftRadius: 10, borderTopRightRadius: 10 }} src={Camera3} />
                                <Typography style={{ textAlign: 'center', fontSize: 10, background: '#fff' }}>{getContent(languageJSON, 'label_back_camera')}</Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    {needToForward ? <Grid item xs={11}>
                        <CustomTextField
                            style={{ backgroundColor: '#fff', width: '100%' }}
                            label={"Enter phone number"}
                            value={phoneNumber}
                            handleChange={(value) => handleChange('phoneNumber', value)} />
                    </Grid> : null}
                    {needToForward ? <Grid item xs={11}>
                        <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%' }} color="primary" handleChange={send} 
                            label={<Typography variant="button">{getContent(languageJSON, 'action_send')}</Typography>} />
                    </Grid> : null}
                </Grid>
            </Container>
            {needToForward ? null : <Grid container justify="center" alignItems="center" spacing={2} style={{ padding: '15px', margin: 0, width: '100%', position: 'absolute', bottom: 0, left: 0, backgroundColor: '#f7fdfd' }}>
                <Grid item xs={11}>
                    <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%' }} color="primary" handleChange={() => goToScreen('selfie')} 
                        label={<Typography variant="button">{getContent(languageJSON, 'action_have_documents')}</Typography>} />
                </Grid>
                <Grid item xs={11}>
                    <CustomButton size="large" variant="contained" style={{ textAlign: 'center', width: '100%' }} color="secondary" handleChange={() => goToScreen('thankyou', { key: 'text_open_link_ready' })} 
                        label={<Typography variant="button">{getContent(languageJSON, 'action_dont_have_documents')}</Typography>} />
                </Grid>
            </Grid>}
        </div>
    )
}

export default Documents